import { useEffect, useState } from "react";
import CallDialog from "./CallDialog";

export default function PhoneGag() {
  const [visible, setVisible] = useState(true);
  const [callOpen, setCallOpen] = useState(false);

  useEffect(() => {
    let lastY = window.scrollY;
    let ticking = false;

    const update = () => {
      ticking = false;
      const y = window.scrollY;
      if (y > lastY && y > 20) {
        setVisible(false);
      } else if (y < lastY && y < 20) {
        setVisible(true);
      }
      lastY = y;
    };

    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <div
        className={`fixed bottom-10 right-8 md:right-16 z-[70] select-none transition-all duration-500 ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
        }`}
      >
        <div className="flex flex-col items-center gap-2">
          {/* Comic speech bubble */}
          <div className="phone-bubble pointer-events-none">
            <span className="phone-bubble-text">
              Wir sind keine Gärtnerei,<br />
              wir machen was mit Kunden.
            </span>
          </div>

          {/* Hopping orange phone - click opens the call dialog */}
          <button
            type="button"
            onClick={() => setCallOpen(true)}
            aria-label="Anruf-Dialog öffnen"
            className="phone-hop cursor-pointer"
          >
            <div className="phone-badge">
              <i className="ri-phone-fill text-[#ff7a1a]"></i>
            </div>
          </button>
        </div>
      </div>

      <CallDialog open={callOpen} onClose={() => setCallOpen(false)} />
    </>
  );
}